import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { finalize } from 'rxjs';

import { AgreementService, Messenger, ProductService } from '../service';

export interface RemoveHoursData {
  owner: string;
  type: string;
  id: string;
  service: ProductService | AgreementService;
}

@Component({
  selector: 'lcm-remove-hours-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogModule, MatButtonModule, MatProgressBarModule],
  template: `
    <h2 mat-dialog-title>Remove hours</h2>
    <mat-dialog-content> Are you sure you want to remove theis hours record? </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button matButton mat-dialog-close [disabled]="pending()">Cancel</button>
      <button matButton [disabled]="pending()" (click)="remove()">Confirm</button>
    </mat-dialog-actions>

    @if (pending()) {
      <mat-progress-bar mode="indeterminate" />
    }
  `,
  styles: ``,
})
export class RemoveHoursDialog {
  data = inject(MAT_DIALOG_DATA) as RemoveHoursData;
  hostDialog = inject(MatDialogRef);
  messenger = inject(Messenger);

  pending = signal(false);

  remove() {
    this.pending.set(true);

    this.data.service
      .removeHours(this.data.owner, this.data.type, this.data.id)
      .pipe(finalize(() => this.pending.set(false)))
      .subscribe({
        next: () => this.hostDialog.close(this.data.id),
        error: this.messenger.handleHttpError,
      });
  }
}
